'use strict';

let mobileOrDesktop;
let dropdownElements;
let overlay;
let navbar;
let toggleMenu;
let menuWrapper;
let lastScrollTop;
let delta;
let navbarHeight;
let st;

/**
 * add or remove class opened as needed
 */
let setClassOpened = function(clicked) {
	if (clicked.parent('li').hasClass('opened')) {
		clicked.parent('li').removeClass('opened');
	} else {
		clicked.parent('li').addClass('opened');
	}
};

/**
 * close mobile menu
 */
let closeMobileMenu = function() {
	$(overlay).removeClass('opened');
	$(navbar).removeClass('open-mobile-menu');
	$(toggleMenu).html('<i class="fas fa-bars" aria-hidden="true"></i>Menu');
};

/**
 * open the mobile menu
 */
let openMobileMenu = function() {
	$(overlay).addClass('opened');
	$(navbar).addClass('open-mobile-menu');
	$(toggleMenu).html('<i class="fas fa-times" aria-hidden="true"></i>Close');
	$(menuWrapper).css('height', $('body').height());
};

/**
 * open or close the mobile menu when Mobile checkbox is clicked
 */
let openCloseMobileMenu = function(clickelement) {
	$(clickelement).on('click', function() {
		if ($(navbar).hasClass('open-mobile-menu')) {
			closeMobileMenu();
		} else {
			openMobileMenu();
		}
	});
};

/**
 * Onclick for checkboxes, toggles the 'opened' class
 * If on desktop, unchecks all other checkboxes to avoid overlapping dropdowns
 */
let onClickCheckHandler = function() {
	$(dropdownElements).each(function() {
		if ($(this)[0].className !== 'menu-checkbox') {
			$(this).off('click');
			$(this).on('click', function() {
				let clicked = $(this);

				setClassOpened(clicked);
				if (mobileOrDesktop === 'desktop') {
					$(dropdownElements).each(function() {
						if ($(this)[0].id !== clicked[0].id) {
							$(this).prop('checked', false).parent('li').removeClass('opened');
						}
					});
				}
			});
		} else {
			openCloseMobileMenu($(this));
		}
	});
};

/**
 * Unchecks all dropdown checkboxes (including menu), thus closing all the dropdowns.
 */
let uncheckAll = function() {
	$(dropdownElements).each(function() {
		$(this).prop('checked', false).parent('li').removeClass('opened');
	});
};

/**
 * Move username in the dom back to after search for desktop view
 */
let moveUsernameForDesktop = function() {
	$('.user-menu-wrapper').appendTo('.username-search-desktop');
};

/**
* Move username in the dom to before search to accomadate mobile navigation
 */
let moveUsernameForMobile = function() {
	$('.user-menu-wrapper').appendTo('.menu-wrapper');
};

/**
 * Determine if the user is on desktop or mobile, and if they are on desktop, uncheck all the dropdown checkboxes
 */
let determineMobileOrDesktop = function() {
	if ($(window).width() < 1090) {
		mobileOrDesktop = 'mobile';
		moveUsernameForMobile();
	} else {
		mobileOrDesktop = 'desktop';
		if (mobileOrDesktop === 'desktop') {
			$(menuWrapper).css('height', 'auto');
			uncheckAll();
			closeMobileMenu();
			moveUsernameForDesktop();
		}
	}
};

/**
 * waits for the user to stop resizing the window before calling anything
 */
let waitForFinalEvent = (function() {
	let timers = {};

	return function(callback, ms, uniqueId) {
		if (!uniqueId) {
			uniqueId = 'Dont call this twice without a uniqueId';
		}
		if (timers[uniqueId]) {
			clearTimeout(timers[uniqueId]);
		}
		timers[uniqueId] = setTimeout(callback, ms);
	};
}());

/**
 * Sets the listener to be sure the user is done resizing the window before calling functions
 */
let setResizeListener = function() {
	$(window).resize(function() {
		waitForFinalEvent(function() {
			determineMobileOrDesktop();
		}, 500, 'some unique string');
	});
};

/**
 * On click outside of mobile menu, closes the mobile menu
 */
let setClickCloseMobileMenu = function() {
	$(overlay).on('click', function() {
		$('.menu-checkbox').trigger('click');
	});
};

/**
 * Edit the html as needed to put in the 1 off joke of a gym subject
 */
let changeGymDropdown = function() {
	let imgSrc = 'https://media1.shmoop.com/media/common/shmoop-bird-animated.gif';
	let imgTag = document.createElement('img');

	imgTag.setAttribute('src', imgSrc);
	// update id drop-gym to remove link tag, append animation
	$('#drop-gym + ul li a').click(false);
	$('#drop-gym + ul li').append(imgTag);
	$('#drop-gym + ul').removeClass('menu');
};

let hasScrolled = function() {
	// Make sure they scroll more than delta
	if(Math.abs(lastScrollTop - st) <= delta) {
		return;
	}

	// If they scrolled down and are past the navbar, add class .nav-up.
	// This is necessary so you never see what is "behind" the navbar.
	if (st > lastScrollTop && st > navbarHeight) {
		// Scroll Down
		$('.shmoop-navbar').removeClass('nav-down').addClass('nav-up');
	} else {
		// Scroll Up
		if(st + $(window).height() < $(document).height()) {
			$('.shmoop-navbar').removeClass('nav-up').addClass('nav-down');
		}
	}

	lastScrollTop = st;
};

/**
 * Scroll Handler to show or hide header
 *
 * Scrolling up, the header should appear, fixed to the top of the page.
 * Scrolling down, the header should disappear by moving up and off the screen.
 */
const scrollHandler = () => {
	let didScroll;

	lastScrollTop = 0;
	delta = 5;
	navbarHeight = $('nav').outerHeight();


	$(window).scroll(function() {
		didScroll = true;
		st = $(this).scrollTop();
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);
};

let init = function() {
	dropdownElements = $('[id^=drop][type=checkbox]');
	overlay = $('.overlay');
	navbar = $('.shmoop-navbar');
	toggleMenu = $('.toggle-menu');
	menuWrapper = $('.menu-wrapper');

	onClickCheckHandler();
	determineMobileOrDesktop();
	setResizeListener();
	setClickCloseMobileMenu();
	changeGymDropdown();
	scrollHandler();
};

module.exports =  {
	init: init
};
